import { gql } from '@apollo/client';

export const updatePersonInfo = gql`
  mutation updatePersonPersonalInfo($input: ModifyPersonInput!) {
    salesforce {
      modifyPerson(input: $input)
    }
  }
`;

export const updatePersonAdditionalInfo = gql`
  mutation modifyPersonDetails($input: ModifyPersonDetailsInput!) {
    salesforce {
      modifyPersonDetails(input: $input)
    }
  }
`;

export const createPersonAddress = gql`
  mutation createPersonAddress($input: CreatePersonAddressInput!) {
    salesforce {
      createPersonAddress(input: $input)
    }
  }
`;

export const updatePersonAddress = gql`
  mutation updatePersonAddress($input: ModifyPersonAddressInput!) {
    salesforce {
      modifyPersonAddress(input: $input)
    }
  }
`;

export const createBusinessPartner = gql`
  mutation createBusinessPartner(
    $createBusinessPartnerInput: CreateBusinessPartnerInput!
  ) {
    salesforce {
      createBusinessPartner(
        createBusinessPartnerInput: $createBusinessPartnerInput
      )
    }
  }
`;

export const createBusinessPartnerVignetteRange = gql`
  mutation createPartnerVignetteRange(
    $createBusinessPartnerVignetteInput: CreateBusinessPartnerVignetteInput!
  ) {
    salesforce {
      createBusinessPartnerVignette(
        createBusinessPartnerVignetteInput: $createBusinessPartnerVignetteInput
      )
    }
  }
`;

export const updateBusinessPartnerVignetteRange = gql`
  mutation updatePartnerVignetteRange(
    $modifyBusinessPartnerVignetteInput: ModifyBusinessPartnerVignetteInput!
  ) {
    salesforce {
      modifyBusinessPartnerVignette(
        modifyBusinessPartnerVignetteInput: $modifyBusinessPartnerVignetteInput
      )
    }
  }
`;

export const updateBusinessPartner = gql`
  mutation updateBusinessPartner(
    $modifyBusinessPartnerInput: ModifyBusinessPartnerInput!
  ) {
    salesforce {
      modifyBusinessPartner(
        modifyBusinessPartnerInput: $modifyBusinessPartnerInput
      )
    }
  }
`;

export const createUser = gql`
  mutation createBusinessUser($businessUserInputs: CreateUserInput!) {
    salesforce {
      createUser(input: $businessUserInputs)
    }
  }
`;

export const updateUser = gql`
  mutation updateBusinessUser($userInput: ModifyUserInput!) {
    core {
      modifyUser(userInput: $userInput)
    }
  }
`;

export const createProvider = gql`
  mutation createProvider($createProviderInput: CreateProviderInput!) {
    salesforce {
      createProvider(createProviderInput: $createProviderInput)
    }
  }
`;

export const createAccountingTransfer = gql`
  mutation createAccoutingTransfer($createTransferInput: CreateTransferInput!) {
    accounting {
      createTransfer(createTransferInput: $createTransferInput)
    }
  }
`;

export const closeMonth = gql`
  mutation closeMonth($closeMonthInput: CloseMonthInput!) {
    reinsurance {
      closeMonth(closeMonthInput: $closeMonthInput) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const generateCloseMonthReport = gql`
  mutation generateCloseMonthReport($closeMonthInput: CloseMonthInput!) {
    reinsurance {
      generateCloseMonthReport(closeMonthInput: $closeMonthInput) {
        content
        contentType
        fileName
      }
    }
  }
`;

export function createClaimPerson() {
  return gql`
    mutation createClaimPerson(
      $claimID: String!
      $personInput: CreateClaimPersonInput!
    ) {
      claimManagement {
        createClaimPerson(claimID: $claimID, personInput: $personInput)
      }
    }
  `;
}
